import React, { useContext, useEffect, useState, useRef } from "react";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { io } from "socket.io-client";
import Contact from "../../components/complain/Contact";
import Chat from "../../components/complain/Chat";
import { UserContext } from "../../context/userContext";

let socket;

function Complain() {
  document.title = "Complain Admin";
  const [contact, setContact] = useState();
  const [contacts, setContacts] = useState([]);
  const [messages, setMessages] = useState([]);
  const [state, dispatch] = useContext(UserContext);

  const contactRef = useRef(contact);
  useEffect(() => {
    contactRef.current = contact;
  }, [contact]);

  useEffect(() => {
    if (!state.user.id) return;

    socket = io(process.env.REACT_APP_SERVER_SOCKET, {
      auth: {
        token: localStorage.getItem("token"),
      },
      query: {
        id: state.user.id,
      },
    });

    socket.on("new message", () => {
      socket.emit("load messages", contactRef.current?.id);
    });

    socket.on("messages", async (data) => {
      if (data.length > 0) {
        const dataMessages = data.map((item) => ({
          idSender: item.sender.id,
          message: item.message,
        }));
        setMessages(dataMessages);
      } else {
        setMessages([]);
      }
      const chatMessages = document.getElementById("chat-messages");
      if (chatMessages) {
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }
    });

    socket.on("custommer contacts", (data) => {
      const dataContacts = data.map((item) => ({
        ...item,
        message: "Click here to start message",
      }));
      setContacts(dataContacts);
    });

    socket.on("connect_error", (err) => {
      // eslint-disable-next-line no-console
      console.error(err.message); // not authorized
    });

    socket.emit("load custommer contacts");

    return () => {
      socket.disconnect();
    };
  }, []);

  const onSendMessage = (e) => {
    if (e.key === "Enter") {
      const data = {
        idRecipient: contact.id,
        message: e.target.value,
      };

      socket.emit("send messages", data);
      e.target.value = "";
    }
  };

  const onClickContact = (data) => {
    setContact(data);
    socket.emit("load messages", data.id);
  };

  return (
    <>
      <NavigasiAdmin active="complain-admin" />
      <div className="container complain-section my-2">
        <div className="row">
          <div className="col-md-4 chat-list">
            <Contact
              dataContact={contacts}
              clickContact={onClickContact}
              contact={contact}
            />
            {/* <div className="row row-chat-section ">
              <div className="col-md-2">
                <img src={chatImg} alt="avatar" />
              </div>
              <div className="col-md-10">
                <span className="name-account">beach_lover</span>
                <span className="message-account text-secondary fw-bold">
                  Hallo Admin, This Problem Product to Me
                </span>
              </div>
            </div> */}
          </div>

          <div className="col-md-8 px-3 d-flex align-items-end">
            <div className="row w-100 mx-auto">
              <Chat
                contact={contact}
                messages={messages}
                user={state.user}
                sendMessage={onSendMessage}
              />
              {/* <div className="col-md-1 d-flex justify-content-center align-items-end">
                <img src={chatImg} alt="avatar" />
              </div>
              <div className="col-md-7">
                <div className="card bg-dark p-3">
                  Hallo Admin, This Problem Product to Me
                </div>
              </div>
              <input
                type="text"
                className="form-control bg-dark mt-5 text-white"
                placeholder="Send Message..."
              /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Complain;
